import { c as _c } from "react/compiler-runtime";
import { Tab, TabGroup, TabList } from '@headlessui/react';
import FunnelHeader from 'modules/funnels/funnel/components/funnel-header';
import FunnelStepsList from 'modules/funnels/funnel/components/funnel-steps-list';
import FunnelStepsListSkeleton from 'modules/funnels/funnel/components/funnel-steps-list-skeleton';
import { FunnelLoco } from 'modules/funnels/funnel/constants/funnel-loco';
import DeviceModeProvider from 'modules/funnels/funnel/context/device-mode-context';
import { FunnelStepSettingTabsEnum } from 'modules/funnels/funnel/enums/funnel-step-setting-tabs-enum';
import useContentScrollingSize from 'modules/funnels/funnel/hooks/use-content-scrolling-styles';
import { useFunnelStepQuery } from 'modules/funnels/funnel/hooks/use-funnel-step-query';
import { useFunnelStepsList } from 'modules/funnels/funnel/hooks/use-funnel-steps-list';
import { useUpdateFunnelStepQuery } from 'modules/funnels/funnel/hooks/use-update-funnel-step-query';
import { FunnelStepInterface } from 'modules/funnels/funnel/types/funnel-step-interface';
import { getFunnelSettingsTabList } from 'modules/funnels/funnel/utils/get-funnel-settings-tab-list';
import { getFunnelStepSettingTabContent } from 'modules/funnels/funnel/utils/get-funnel-step-setting-tab-content';
import { FunnelId } from 'modules/funnels/types/funnel-interface';
import { NextPage } from 'next';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { updateFunnelStepInDB } from 'shared/db/utils/funnels';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { getBaseServerSideProps } from 'shared/utils/get-base-server-side-props';
import useMediaQuery from 'shared/hooks/use-media-query';
const Funnel: NextPage = () => {
  const $ = _c(81);
  const router = useRouter();
  const {
    t
  } = useLocoTranslation();
  const funnelId = parseInt(router.query.funnelId as string) as FunnelId;
  const {
    funnelStepsList,
    mutateFunnelStepsList
  } = useFunnelStepsList(funnelId);
  const {
    updateFunnelStepQuery,
    clearFunnelStepTabQuery
  } = useUpdateFunnelStepQuery();
  const {
    isXS: isMobile
  } = useMediaQuery();
  const {
    contentRef,
    contentHeight,
    listHeight,
    listRef
  } = useContentScrollingSize(isMobile);
  const [selectedFunnelStep, setSelectedFunnelStep] = useState(null);
  const [selectedTab, setSelectedTab] = useState(null);
  const settingsTabsList = getFunnelSettingsTabList(selectedFunnelStep?.type);
  let t0;
  if ($[0] !== funnelId || $[1] !== isMobile || $[2] !== updateFunnelStepQuery) {
    t0 = function selectFunnelStep(funnelStep) {
      setSelectedFunnelStep(funnelStep);
      updateFunnelStepQuery(funnelStep.id);
      if (!isMobile) {
        setSelectedTab(FunnelStepSettingTabsEnum.stepConfiguration);
        updateFunnelStepQuery(funnelStep.id, FunnelStepSettingTabsEnum.stepConfiguration);
      }
      updateFunnelStepInDB(funnelId, funnelStep.id);
    };
    $[0] = funnelId;
    $[1] = isMobile;
    $[2] = updateFunnelStepQuery;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const selectFunnelStep = t0;
  let t1;
  if ($[4] !== updateFunnelStepQuery) {
    t1 = function selectFunnelStepTab(tabType, funnelStep_0) {
      if (funnelStep_0) {
        setSelectedTab(tabType);
        updateFunnelStepQuery(funnelStep_0.id, tabType);
      }
    };
    $[4] = updateFunnelStepQuery;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const selectFunnelStepTab = t1;
  const isFunnelListIsEmpty = funnelStepsList && funnelStepsList.length === 0;
  let t2;
  if ($[6] !== clearFunnelStepTabQuery) {
    t2 = () => {
      clearFunnelStepTabQuery();
      setSelectedTab(null);
    };
    $[6] = clearFunnelStepTabQuery;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const resetSelectedMobileTab = t2;
  let t3;
  if ($[8] !== funnelStepsList) {
    t3 = {
      funnelStepsList,
      setSelectedFunnelStep
    };
    $[8] = funnelStepsList;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const {
    selectedFunnelStepId,
    selectedFunnelStepTab
  } = useFunnelStepQuery(t3);
  let t4;
  if ($[10] !== funnelId || $[11] !== funnelStepsList || $[12] !== isMobile || $[13] !== selectedFunnelStep?.id || $[14] !== selectedFunnelStepId || $[15] !== selectedFunnelStepTab) {
    t4 = () => {
      if (funnelStepsList && Number(selectedFunnelStepId) !== selectedFunnelStep?.id) {
        const selectedFunnelStepEntity = funnelStepsList.find(funnelStep_1 => funnelStep_1.id === Number(selectedFunnelStepId));
        if (selectedFunnelStepEntity && selectedFunnelStepId) {
          setSelectedFunnelStep(selectedFunnelStepEntity);
          updateFunnelStepInDB(funnelId, selectedFunnelStepId);
          if (selectedFunnelStepTab) {
            setSelectedTab(selectedFunnelStepTab);
          } else {
            if (isMobile) {
              setSelectedTab(null);
            } else {
              setSelectedTab(FunnelStepSettingTabsEnum.stepConfiguration);
            }
          }
        }
      }
    };
    $[10] = funnelId;
    $[11] = funnelStepsList;
    $[12] = isMobile;
    $[13] = selectedFunnelStep?.id;
    $[14] = selectedFunnelStepId;
    $[15] = selectedFunnelStepTab;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  let t5;
  if ($[17] !== funnelStepsList || $[18] !== isMobile || $[19] !== selectedFunnelStepId) {
    t5 = [selectedFunnelStepId, funnelStepsList, isMobile];
    $[17] = funnelStepsList;
    $[18] = isMobile;
    $[19] = selectedFunnelStepId;
    $[20] = t5;
  } else {
    t5 = $[20];
  }
  useEffect(t4, t5);
  let t6;
  let t7;
  if ($[21] !== isMobile || $[22] !== selectedTab) {
    t6 = () => {
      if (!isMobile && !selectedTab) {
        setSelectedTab(FunnelStepSettingTabsEnum.stepConfiguration);
      }
    };
    t7 = [isMobile, selectedTab];
    $[21] = isMobile;
    $[22] = selectedTab;
    $[23] = t6;
    $[24] = t7;
  } else {
    t6 = $[23];
    t7 = $[24];
  }
  useEffect(t6, t7);
  let t8;
  if ($[25] !== updateFunnelStepQuery) {
    t8 = () => {
      if (window.location.hash) {
        const stepId = window.location.hash.replace("#step", "");
        updateFunnelStepQuery(Number(stepId));
      }
    };
    $[25] = updateFunnelStepQuery;
    $[26] = t8;
  } else {
    t8 = $[26];
  }
  let t9;
  if ($[27] !== router) {
    t9 = [router];
    $[27] = router;
    $[28] = t9;
  } else {
    t9 = $[28];
  }
  useEffect(t8, t9);
  const T0 = DeviceModeProvider;
  const t10 = "flex flex-col gap-5";
  let t11;
  if ($[29] !== funnelId || $[30] !== selectedFunnelStep) {
    t11 = <FunnelHeader funnelId={funnelId} selectedFunnelStep={selectedFunnelStep} />;
    $[29] = funnelId;
    $[30] = selectedFunnelStep;
    $[31] = t11;
  } else {
    t11 = $[31];
  }
  const t12 = "flex flex-col gap-3 lg:flex-row lg:gap-6";
  const t13 = `relative w-full lg:min-h-fit lg:w-[330px] ${isMobile && selectedTab && !isFunnelListIsEmpty ? "hidden" : ""}`;
  let t14;
  if ($[32] !== funnelId || $[33] !== funnelStepsList || $[34] !== listHeight || $[35] !== listRef || $[36] !== mutateFunnelStepsList || $[37] !== selectFunnelStep || $[38] !== selectedFunnelStep) {
    t14 = !funnelStepsList ? <FunnelStepsListSkeleton /> : <FunnelStepsList funnelId={funnelId} funnelSteps={funnelStepsList} mutate={mutateFunnelStepsList} selectedFunnelStep={selectedFunnelStep} selectFunnelStep={selectFunnelStep} listHeight={listHeight} listRef={listRef} />;
    $[32] = funnelId;
    $[33] = funnelStepsList;
    $[34] = listHeight;
    $[35] = listRef;
    $[36] = mutateFunnelStepsList;
    $[37] = selectFunnelStep;
    $[38] = selectedFunnelStep;
    $[39] = t14;
  } else {
    t14 = $[39];
  }
  let t15;
  if ($[40] !== t13 || $[41] !== t14) {
    t15 = <div className={t13}>{t14}</div>;
    $[40] = t13;
    $[41] = t14;
    $[42] = t15;
  } else {
    t15 = $[42];
  }
  const t16 = "bg-background-secondary customScroll flex h-full min-h-[200px] w-full flex-col items-stretch gap-5 overflow-x-hidden rounded-md";
  let t17;
  if ($[43] !== contentHeight) {
    t17 = contentHeight ? {
      height: contentHeight,
      overflowY: "scroll"
    } : {};
    $[43] = contentHeight;
    $[44] = t17;
  } else {
    t17 = $[44];
  }
  const t18 = "flex flex-col gap-7 lg:gap-10";
  const T1 = TabGroup;
  const T2 = TabList;
  const t19 = `funnelCustomScroll flex flex-col gap-y-0 overflow-x-auto lg:flex-row ${isMobile && selectedTab ? "hidden" : ""}`;
  let t20;
  if ($[45] !== isFunnelListIsEmpty || $[46] !== selectFunnelStepTab || $[47] !== selectedFunnelStep || $[48] !== selectedTab || $[49] !== t) {
    t20 = tab => <Tab onClick={() => selectFunnelStepTab(tab.type, selectedFunnelStep)} key={tab.type} disabled={isFunnelListIsEmpty} className={`${tab.type === selectedTab ? "lg:text-text-primary lg:border-b-brand-primary lg:border-b-[3px]" : "lg:border-b-text-primary/15 lg:border-b-1"} lg:main-transition-colors border-[rgb(var(--text-primary))]/15 w-full border-b-[1px] px-4 py-4 outline-hidden last:border-b-[0px] lg:w-fit lg:pb-[22px] lg:pt-[27px] lg:first:pl-8 lg:last:border-b-[1px]`}><div className="flex gap-2">{tab.iconRenderer(tab.type === selectedTab)}<span className="font-inter whitespace-nowrap font-semibold sm:text-[15px]">{t(tab.caption)}</span></div></Tab>;
    $[45] = isFunnelListIsEmpty;
    $[46] = selectFunnelStepTab;
    $[47] = selectedFunnelStep;
    $[48] = selectedTab;
    $[49] = t;
    $[50] = t20;
  } else {
    t20 = $[50];
  }
  const t21 = settingsTabsList.map(t20);
  let t22;
  if ($[51] !== T2 || $[52] !== t19 || $[53] !== t21) {
    t22 = <T2 className={t19}>{t21}</T2>;
    $[51] = T2;
    $[52] = t19;
    $[53] = t21;
    $[54] = t22;
  } else {
    t22 = $[54];
  }
  let t23;
  if ($[55] !== T1 || $[56] !== t22) {
    t23 = <T1>{t22}</T1>;
    $[55] = T1;
    $[56] = t22;
    $[57] = t23;
  } else {
    t23 = $[57];
  }
  let t24;
  if ($[58] !== funnelId || $[59] !== isFunnelListIsEmpty || $[60] !== selectedFunnelStep || $[61] !== selectedTab) {
    t24 = getFunnelStepSettingTabContent(funnelId, selectedFunnelStep, selectedTab, isFunnelListIsEmpty);
    $[58] = funnelId;
    $[59] = isFunnelListIsEmpty;
    $[60] = selectedFunnelStep;
    $[61] = selectedTab;
    $[62] = t24;
  } else {
    t24 = $[62];
  }
  let t25;
  if ($[63] !== contentRef || $[64] !== t23 || $[65] !== t24) {
    t25 = <div className={t18} ref={contentRef}>{t23}{t24}</div>;
    $[63] = contentRef;
    $[64] = t23;
    $[65] = t24;
    $[66] = t25;
  } else {
    t25 = $[66];
  }
  let t26;
  if ($[67] !== t17 || $[68] !== t25) {
    t26 = <div className={t16} style={t17}>{t25}</div>;
    $[67] = t17;
    $[68] = t25;
    $[69] = t26;
  } else {
    t26 = $[69];
  }
  let t27;
  if ($[70] !== t15 || $[71] !== t26) {
    t27 = <div className={t12}>{t15}{t26}</div>;
    $[70] = t15;
    $[71] = t26;
    $[72] = t27;
  } else {
    t27 = $[72];
  }
  let t28;
  if ($[73] !== t11 || $[74] !== t27) {
    t28 = <div className={t10}>{t11}{t27}</div>;
    $[73] = t11;
    $[74] = t27;
    $[75] = t28;
  } else {
    t28 = $[75];
  }
  let t29;
  if ($[76] !== T0 || $[77] !== isMobile || $[78] !== resetSelectedMobileTab || $[79] !== t28) {
    t29 = <T0 resetSelectedMobileTab={resetSelectedMobileTab} isMobile={isMobile}>{t28}</T0>;
    $[76] = T0;
    $[77] = isMobile;
    $[78] = resetSelectedMobileTab;
    $[79] = t28;
    $[80] = t29;
  } else {
    t29 = $[80];
  }
  return t29;
};
export const getServerSideProps = getBaseServerSideProps(FunnelLoco, 'header.top_menu.funnels');
export default Funnel;